module.exports = __webpack_public_path__ + "static/media/proyectouno.c3919e10.png";